import React from 'react';

import ButtonFilled from '../../components/common/Buttons/ButtonFilled';

import { useCommonStore } from '../../stores/commonStore';

import { VisualQCStatus } from '../../utils/enums';
import { VisualQC } from './VisualQCStatus';

const ModelActions = () => {
    const fsns = useCommonStore((state) => state.threeDLiveFsns);
    const activeProduct = useCommonStore((state) => state.activeFSN);
    const setVisualQCStatus = useCommonStore((state) => state.setVisualQCStatus);

    const visualQCStatus = fsns?.filter((item) => item.fsn === activeProduct)[0]?.visualQCStatus;

    return (
        <div className="flex bg-white px-4  shadow-sm w-full justify-between" style={{ height: 108, border: '1px solid #E5E7EB' }}>
            <div className="min-w-20">
                {visualQCStatus && visualQCStatus !== VisualQCStatus.PENDING ? (
                    <h3 className="text text-gray-900 dark:text-white pb-2 flex flex-col justify-center h-full">
                        <p> You Choose:</p>
                        <VisualQC status={visualQCStatus} />
                    </h3>
                ) : null}
            </div>
            <div className="flex gap-4 justify-center items-center">
                <span style={{ fontSize: 18, fontWeight: 500 }}>Mark</span>
                <button
                    onClick={() => setVisualQCStatus(activeProduct, VisualQCStatus.PASSED)}
                    disabled={visualQCStatus !== VisualQCStatus.PENDING}
                    style={{ border: '1px solid #E5E7EB', fontSize: 16, fontWeight: 400, color: visualQCStatus === VisualQCStatus.PENDING ? '#000000' : '#6B7280' }}
                    className={`py-2 px-4 transition ease-in duration-200 text-center focus:outline-none rounded-md color-white}`}
                >
                    Approve
                </button>
                <button
                    onClick={() => setVisualQCStatus(activeProduct, VisualQCStatus.FAILED)}
                    disabled={visualQCStatus !== VisualQCStatus.PENDING}
                    style={{ border: '1px solid #E5E7EB', fontSize: 16, fontWeight: 400, color: visualQCStatus === VisualQCStatus.PENDING ? '#000000' : '#6B7280' }}
                    className={`py-2 px-4 transition ease-in duration-200 text-center   focus:outline-none rounded-md color-white}`}
                >
                    Not Approve
                </button>
                <button
                    onClick={() => setVisualQCStatus(activeProduct, VisualQCStatus.PENDING)}
                    disabled={visualQCStatus === VisualQCStatus.PENDING}
                    style={{ fontSize: 16, fontWeight: 400, backgroundColor: visualQCStatus === VisualQCStatus.PENDING ? '#6B7280' : '#2A55E5' }}
                    className={`py-2 px-4 text-white transition ease-in duration-200 text-center   focus:outline-none rounded-md }`}
                >
                    Reset
                </button>
            </div>
        </div>
    );
};

export default React.memo(ModelActions);
